import { COUNTERPARTY_NAMES } from '../../model/consts/COUNTERPARTY_NAMES';

export function getCounterpartyTypeName(type: string): string {
  return COUNTERPARTY_NAMES[type];
}